import type {SessionApprovalMode} from '@github-ui/ahp-relay/permission-mode'

export interface ApprovalModePresentation {
  label: string
  description: string
  experimental?: boolean
}

/**
 * Shared copy for the session's tool-permission modes.
 *
 * The permissions dropdown and the `/permissions` slash command both render from
 * this record so the two surfaces cannot describe the same mode differently.
 */
export const APPROVAL_MODE_PRESENTATION: Record<SessionApprovalMode, ApprovalModePresentation> = {
  manual: {
    label: 'Always ask',
    description: 'Require approval for each request.',
  },
  assisted: {
    label: 'Assisted',
    description: 'Automatically approve tool requests that pass an LLM safety check. Ask otherwise.',
    experimental: true,
  },
  'allow-all': {
    label: 'Allow all',
    description: 'Auto-approve all tool, path, and URL requests.',
  },
}

export const APPROVAL_MODE_SHOW_DESCRIPTION = 'Show the current permission status.'
